import { format, isEqual, parse, set } from "date-fns";
import { useDeltaToastContext } from "./contexts/ToasterContext";
import { zonedTimeToUtc } from "date-fns-tz";

const ExtendLicense: React.FC<{
  handleExtend: () => void;
  extensionDate: number;
  setExtensionDate: React.Dispatch<React.SetStateAction<number>>;
  licenseExpiration: Date;
  schoolYear?: string;
}> = ({
  handleExtend,
  extensionDate,
  setExtensionDate,
  licenseExpiration,
  schoolYear,
}) => {
  const toastContext = useDeltaToastContext();

  //schoolYear is more reliable for the extension dates we want, but we can use licenseExpiration as a fallback
  let year = licenseExpiration.getFullYear();
  try {
    //last two digits of school year - assume schoolYear is in the format "yy-yy" or "yy-yy [Full Year / Prorated]"
    const digits = schoolYear?.match(/^\d{2}-\d{2}/)?.[0].split("-")[1];
    if (digits) {
      year = 2000 + parseInt(digits, 10);
    }
  } catch {
    year = licenseExpiration.getFullYear();
  }

  const baseDates = [
    `${year}-10-01`,
    `${year}-10-15`,
    `${year}-11-01`,
    `${year}-11-15`,
    `${year}-12-01`,
    `${year}-12-15`,
    `${year + 1}-01-01`,
  ];

  const dateStrings = baseDates.map((date) => {
    const fullDateTime = set(parse(date, "yyyy-MM-dd", new Date()), {
      hours: 23,
      minutes: 59,
      seconds: 0,
    });
    return zonedTimeToUtc(fullDateTime, "America/New_York").toISOString();
  });

  const datesToRender = dateStrings.filter(
    (dateStr) => !isEqual(new Date(dateStr), licenseExpiration)
  );

  return (
    <div className="flex flex-row items-center">
      <select
        className="mx-2 rounded text-xs"
        id="extension-date"
        value={extensionDate}
        onChange={(e) => setExtensionDate(Number(e.target.value))}
      >
        <option value="">Select a date</option>
        {datesToRender.map((dateStr) => {
          const date = new Date(dateStr);
          return (
            <option key={dateStr} value={Math.floor(date.getTime() / 1000)}>
              {format(date, "MMM. d, yyyy")}
            </option>
          );
        })}
      </select>
      <button
        type="button"
        className="ml-2 inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        onClick={() => {
          if (extensionDate) {
            handleExtend();
          } else {
            toastContext.addToast({
              message: `Please select an extension date`,
              status: "Error",
            });
          }
        }}
      >
        Extend
      </button>
    </div>
  );
};

export default ExtendLicense;
